<template>
  <div
    class="template-wrap so-day-event-template"
    v-bind:style="{
      'background-color': data.TransportStatusHexColour,
    }"
  >
    <div class="main_subject">
      <span>{{ data.subject }}</span>
      <span> {{ data.WorkOrderFriendlyStatus }} </span>
    </div>
    <div class="subject">
      <span>SO # {{ data.SalesOrderCode }}</span>
      <span>{{ data.TransportStatus }}</span>
    </div>
    <div class="customer">
      <span>{{ data.CustomerName }}</span>
      <span>{{ getFormattedDate(data.SalesOrderShipDate) }}</span>
    </div>
    <div class="data">
      <div class="data-items">
        <div class="planned">
          <span>
            {{ data.ProductCode }}
          </span>
        </div>
        <div class="actual">
          <span>Ordered</span>&nbsp;
          <span>
            {{ getFormattedQty(data.SalesOrderStockUMQuantity) }}
            {{ data.StockUM }}
          </span>
        </div>
      </div>
      <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
    </div>
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";
export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    getFormattedDate(value) {
      return new Date(value).toShortDateString();
    },
  },
};
</script>

<style lang="scss">
.e-appointment-details {
  .so-day-event-template {
    padding: 5px 5px;

    .main_subject {
      border-bottom: 2px solid;
      margin-bottom: 2px;
      padding-bottom: 1px;
    }

    .main_subject,
    .subject,
    .customer {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .main_subject,
    .subject,
    .customer {
      span:last-child {
        font-size: 10px;
      }
    }

    .description {
      font-size: 12px;
    }

    .data {
      width: 100%;
      font-size: 10px;
      display: inline-flex;
      justify-content: space-between;

      .data-items {
        display: flex;
      }

      .actual {
        padding-left: 25px;
      }
    }
  }
}
</style>
